import cn from 'classnames';

import type { CSSProperties } from 'react';
import styles from './WarningBlock.module.scss';

export const WarningBlockDefaultAsType = 'div' as const;

export type WarningBlockElement = React.ElementType;

export type WarningBlockOwnProps<E extends WarningBlockElement> = {
  children: React.ReactNode;
  as?: E;
  color?: string;
};

export type WarningBlockProps<E extends WarningBlockElement> =
  WarningBlockOwnProps<E> &
    Omit<React.ComponentProps<E>, keyof WarningBlockOwnProps<E>>;

export function WarningBlock<
  E extends React.ElementType = typeof WarningBlockDefaultAsType
>({ children, as, className, color, ...otherProps }: WarningBlockProps<E>) {
  const Tag = as || WarningBlockDefaultAsType;

  return (
    <Tag
      className={cn(styles.warningBlock, className)}
      {...otherProps}
      style={{ '--warningColor': color } as CSSProperties}
    >
      {children}
    </Tag>
  );
}
